<template>
  <main>
    <!-- Global Loader -->
    <!-- <Loader v-if="loading" /> -->

    <!-- App Content -->
    <!-- <section v-else-if="showNav"> -->
     <section v-if="showNav">
      <b-navbar ref="mainNavbar">
        <template #brand>
          <b-navbar-item tag="router-link" :to="{ path: '/' }">
            <img src="@/assets/teamwrkr.png" alt="Teamwrkr Logo" />
          </b-navbar-item>
        </template>

        <template v-if="user && showNavItems" #start>
          <!-- <b-navbar-item class="main-nav-link" tag="router-link" :to="{ path: `/team` }" exact>
            Team
          </b-navbar-item> -->
          <!-- <b-navbar-item tag="router-link" :to="{ path: `/sales` }">
            Sales
          </b-navbar-item> -->
          <!-- <b-navbar-item
            tag="a"
            :href="`https://community.teamwrkr.com/`"
            target="_blank"
            rel="noopener"
          >
            Community
          </b-navbar-item> -->
          <!-- <b-navbar-dropdown v-if="user && adminWhitelist.includes(user.email)" label="Admin">
            <b-navbar-item tag="router-link" :to="{ path: '/admin/onboarding-data' }">
              Onboarding Data
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/admin/rejected-manager-verifications' }">
              Rejected Manager Verifications
            </b-navbar-item>
          </b-navbar-dropdown> -->
        </template>

        <template #end>
          <b-navbar-item tag="div">
            <div class="buttons">
              <router-link
                v-if="(!user || !user._id) && !showJoin"
                class="button is-primary"
                :to="{ path: '/verify' }"
              >
                <strong>Already have an account?</strong>
              </router-link>
              <router-link
                v-if="(!user || !user._id) && showJoin"
                class="button is-primary"
                :to="{ path: '/welcome' }"
              >
                <strong>Get A Profile!</strong>
              </router-link>
              <!-- <b-button
                v-if="user && user?._id && user?.isStatsheetLocked"
                class="review-launch-btn"
                @click="openVerifiedModal"
              >
                <i class="mdi mdi-star"></i>
                Get Verified
              </b-button> -->
              <b-dropdown
                v-if="user && user._id"
                position="is-bottom-left"
                aria-role="list"
                class="user-menu"
              >
                <template #trigger>
                  <UserAvatar :user="user" />
                </template>
                <div class="user-menu__section-label">Me</div>
                <b-dropdown-item aria-role="listitem" @click="openAccountModal">
                  Account
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="navToProfile">
                  My Profile
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="navToPublicStatSheet">
                  View My Profile
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="navToStatSheet">
                  Update My Profile
                </b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="navToCareerPathways">
                  Career Pathways
                </b-dropdown-item>

                <div v-if="user.isAdmin" class="user-menu__divider"></div>
                <div v-if="user.isAdmin" class="user-menu__section-label">Company</div>
                <b-dropdown-item
                  v-if="user.isAdmin"
                  aria-role="listitem"
                  @click="navToCompany"
                >
                  Company
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="user.isAdmin"
                  aria-role="listitem"
                  @click="navToBusinessContext"
                >
                  Business Context
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="user.isAdmin"
                  aria-role="listitem"
                  @click="navToPsaWorkflowRules"
                >
                  PSA Workflow Rules
                </b-dropdown-item>

                <template v-if="user.isSuperUser">
                  <div class="user-menu__divider"></div>
                  <div class="user-menu__section-label">Support</div>
                  <b-dropdown-item aria-role="listitem" @click="navToSuperUser">
                    Super User
                  </b-dropdown-item>
                </template>

                <div class="user-menu__divider"></div>
                <div class="user-menu__section-label">Session</div>
                <b-dropdown-item aria-role="listitem" @click="logout">
                  Logout
                </b-dropdown-item>
              </b-dropdown>
              <notification-system
                v-if="user && user._id"
                :notifications="notifications"
                @notification-action="notificationAction"
              />
            </div>
          </b-navbar-item>
        </template>
      </b-navbar>
    </section>

    <!-- Modals and Router -->
    <get-verified-modal
      v-if="user && user._id"
      :user="user"
      v-model:showModal="showVerifiedModal"
    />
    <b-modal
      v-model="showAccountModal"
      :can-cancel="['escape', 'outside', 'button']"
      :width="520"
      trap-focus
    >
      <div class="account-modal">
        <div class="modal-content">
          <h2 class="modal-title">
            <i class="mdi mdi-account-edit"></i>
            Account
          </h2>
          <p class="modal-desc">
            Update your account details.
          </p>
          <b-field label="First Name">
            <b-input v-model="accountForm.firstName" placeholder="First name" />
          </b-field>
          <b-field label="Last Name">
            <b-input v-model="accountForm.lastName" placeholder="Last name" />
          </b-field>
          <b-field label="Email">
            <b-input v-model="accountForm.email" type="email" placeholder="Email" />
          </b-field>
          <div class="modal-actions">
            <b-button type="is-primary" :loading="savingAccount" @click="saveAccount">
              Save
            </b-button>
            <b-button type="is-text" @click="showAccountModal = false">
              Cancel
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <ImpersonationBanner v-if="isImpersonating" />
    <FeedbackLauncher v-if="hideFeedback" />
    <router-view style="padding-top: 2rem;"></router-view>
  </main>
</template>

<script>
import { useUserStore } from '@/stores/userStore'
import { mapState } from 'pinia'
// import Loader from '@/components/Loader.vue'
import GetVerifiedModal from '@/components/home/GetVerifiedModal.vue'
import FeedbackLauncher from '@/components/FeedbackLauncher.vue'
import UserAvatar from './components/UserAvatar.vue'
import NotificationSystem from '@/components/home/NotificationSystem.vue'
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'

export default {
  name: 'App',
  components: {
    // Loader,
    GetVerifiedModal,
    FeedbackLauncher,
    NotificationSystem,
    UserAvatar,
    ImpersonationBanner,
  },
  data() {
    return {
      showVerifiedModal: false,
      adminWhitelist: ['andy@teamwrkr.com', 'phil@teamwrkr.com'],
      showAccountModal: false,
      savingAccount: false,
      accountForm: {
        firstName: '',
        lastName: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapState(useUserStore, ['user', 'loading', 'notifications', 'isImpersonating']),
    showNav() {
      return this.$route?.meta?.showNav ?? true
    },
    showNavItems() {
      return this.$route?.meta?.showNavItems ?? true
    },
    hideFeedback() {
      return !this.$route?.meta?.hideFeedback ?? false
    },
    showJoin() {
      return this.$route?.meta?.showJoin ?? false
    },
  },
  methods: {
    openVerifiedModal() {
      if (this.$refs.mainNavbar?.isActive) {
        this.$refs.mainNavbar.isActive = false
      }
      this.showVerifiedModal = true
    },
    notificationAction(notification) {
      this.markNotificationAsRead(notification._id)
      if (notification.link) this.$router.push(notification.link)
    },
    openAccountModal() {
      this.accountForm = {
        firstName: this.user?.firstName || '',
        lastName: this.user?.lastName || '',
        email: this.user?.email || ''
      }
      this.showAccountModal = true
    },
    navToProfile() {
      this.$router.push(`/member/${this.user._id}`);
    },
    navToPublicStatSheet() {
      this.$router.push(`/profile/${this.user._id}`);
    },
    navToStatSheet() {
      this.$router.push('/profile')
    },
    navToCareerPathways() {
      this.$router.push('/career-pathways');
    },
    navToBusinessContext() {
      this.$router.push('/company/business-context')
    },
    navToPsaWorkflowRules() {
      this.$router.push('/company/psa-workflow-rules');
    },
    navToCompany() {
      this.$router.push('/company')
    },
    navToSuperUser() {
      this.$router.push('/superuser')
    },
    async saveAccount() {
      if (!this.user?._id) return
      this.savingAccount = true
      try {
        const response = await this.axios.patch(
          `${process.env.VUE_APP_API_URL}/users/me`,
          {
            firstName: this.accountForm.firstName,
            lastName: this.accountForm.lastName,
            email: this.accountForm.email
          },
          { headers: { Authorization: this.$cookies.get('teamwrkr-token') } }
        )
        const userStore = useUserStore()
        if (response?.data) {
          userStore.setUser(response.data)
        }
        this.$buefy.toast.open({
          message: 'Account updated successfully.',
          type: 'is-success'
        })
        this.showAccountModal = false
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update account.',
          type: 'is-danger'
        })
      } finally {
        this.savingAccount = false
      }
    },
    async markNotificationAsRead(notificationId) {
      try {
        await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/notifications-read/${notificationId}`,
          {},
          { headers: { Authorization: this.$cookies.get('teamwrkr-token') } }
        )
      } catch (error) {
        console.error('Error marking notification as read:', error)
      }
    },
    logout() {
      this.$cookies.remove('teamwrkr-token')
      const userStore = useUserStore()
      userStore.$reset()
      this.$router.push('/reset')
    },
  },
}
</script>



<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $color-text-strong;
  background: $color-surface;
}

.navbar-brand {
  padding-left: 1.75rem;
  // padding-top: 0.5rem;
  .navbar-item .buttons {
    justify-content: center;
    .button.is-primary {
      background-color: $color-primary;
    }
  }
  img {
    max-height: 2.25rem;
  }
}
.navbar-menu {
  padding-top: 0.5rem;
}

.navbar {
  background: $color-surface;
  border-bottom: 1px solid $color-border;
  box-shadow: $shadow-xs;
}

.navbar-item,
.navbar-link {
  font-weight: 600;
  color: $color-text;
}

.navbar-item.is-active,
.navbar-link.is-active,
.navbar-item.router-link-active,
.navbar-item.router-link-exact-active,
.navbar-link.router-link-active,
.navbar-link.router-link-exact-active {
  color: $color-primary;
}

.main-nav-link.router-link-active,
.main-nav-link.router-link-exact-active {
  position: relative;
  color: $color-primary;
}

.main-nav-link.router-link-active::after,
.main-nav-link.router-link-exact-active::after {
  content: '';
  position: absolute;
  left: 1rem;
  right: 1rem;
  bottom: 0.35rem;
  height: 2px;
  border-radius: 999px;
  background: $color-primary;
}

.navbar .dropdown-menu .dropdown-content {
  text-align: left;
}

.navbar .dropdown-menu .dropdown-item {
  justify-content: flex-start;
  text-align: left;
}

.user-menu__section-label {
  padding: 0.45rem 1rem 0.3rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $color-text-subtle;
}

.user-menu__divider {
  height: 1px;
  margin: 0.35rem 0;
  background: $color-border;
}

.review-launch-btn {
  border-radius: $radius-pill;
  box-shadow: none;
  background: $color-surface-soft;
}

.account-modal {
  .modal-content {
    padding: 1.5rem;
    background: $color-surface;
    border-radius: 0.75rem;
    color: $color-text;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .modal-title {
    font-size: 1.35rem;
    font-weight: 700;
    color: $color-primary;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .modal-desc {
    font-size: 1rem;
    color: $color-text-muted;
  }

  .modal-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
  }
}
</style>
